import { Injectable } from '@angular/core';

import { BaseEditService } from 'tms-lib';
import { SupplierAddress, SupplierAddressEdit } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SupplierAddressService extends BaseEditService<SupplierAddress, SupplierAddressEdit> {
  constructor() {
    super('SupplierAddress', $localize`Supplier Address`);
  }
}
